import {tokenDefinition} from "../../token/tokenDefinition.mjs";
import {TokenType} from  "../../token/tokenType.mjs";
import {TokenName} from "./tokenName.mjs";
import {NodeName} from "./nodeName.mjs";
import {Node} from "../../node/node.mjs";

class TableColumn {

  constructor() {
  }

  consume(tokenIterator, nodeIterator) {
    if(this.isOpening(tokenIterator, nodeIterator)) {
      this.openNewNode(tokenIterator, nodeIterator)
    }
    if(this.isClosing(tokenIterator, nodeIterator)) {
      this.closeNode(tokenIterator, nodeIterator)
    }
  }

  isOpening(tokenIterator, nodeIterator) {
    return nodeIterator.currentParentNode.name === NodeName.TABLE_ROW
        && tokenIterator.hasNext(2)
        && tokenIterator.token().name === TokenName.PIPE
        && tokenIterator.peekNext(1) !== TokenName.LINE_FEED // TODO: make this more robust by checking blanks
  }

  isClosing(tokenIterator, nodeIterator) {
    return !tokenIterator.token()
        || tokenIterator.token().name === TokenName.PIPE
  }

  openNewNode(tokenIterator, nodeIterator) {

    // skip the pipe
    tokenIterator.eatTokens(1)

    const value = tokenIterator.token() ?
        tokenIterator.token().value :
        null

    nodeIterator.addOpenNode(new Node(
        NodeName.TABLE_COLUMN,
        value,
        new TableColumn(),
        nodeIterator.currentParentNode
    ))
  }

  closeNode(tokenIterator, nodeIterator) {
    // find row node and close it
    let openNodeIndex = nodeIterator.indexOfLastOpen(NodeName.TABLE_COLUMN)
    if(openNodeIndex === null) return
    nodeIterator.closeNodeAtIndex(openNodeIndex);

    if(this.HasNextColumn(tokenIterator)) {
      this.openNewNode(tokenIterator, nodeIterator)
    }
  }

  toHtml(node, toHtml, idProvider) {
    var content = ""
    for(const child of node.children) {
      content += toHtml(child, idProvider)
    }

    if(node.parent.name === NodeName.TABLE_HEADER) {
      return "<th>" + content + "</th>"
    }
    return "<td>" + content + "</td>"
  }

  HasNextColumn(tokenIterator) {
    return tokenIterator.hasNext(3)
        && tokenIterator.peekNext(1).name !== TokenName.LINE_FEED
        && tokenIterator.peekNext(2).name !== TokenName.LINE_FEED;
  }

  onEndOfMarkup(openNode) {
    openNode.close()
  }

}
export {TableColumn}